import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { SIZE } from '../../../constants/size'
import { useNotification, useTimeZone } from '../../../hooks'
import { ConfirmationModal } from '../../Confirmation'
import Text from '../../Text'
import { answerAppointmentFollowUp } from '../Appointment.api'
import { getIsAppointmentDueDateChangedError } from '../Appointment.utils'

import { QA_NAME_APPOINTMENT_FOLLOW_UP_MODAL } from './AppointmentFollowUpModal.constants'
import {
  getAppointmentFollowUpApplyData,
  getAppointmentFollowUpBeforeKey,
  getAppointmentFollowUpConfirmKey,
  getAppointmentFollowUpDateLabel,
  getAppointmentFollowUpDeclineKey,
  getAppointmentFollowUpReasonKey,
  getAppointmentFollowUpRequestLabel,
} from './AppointmentFollowUpModal.utils'
import { AppointmentFollowUpModalButtons } from './AppointmentFollowUpModalButtons'
import { AppointmentFollowUpModalDayLoad } from './AppointmentFollowUpModalDayLoad'

import * as styles from './AppointmentFollowUpModal.module.css'

function AppointmentFollowUpModal({
  appointment,
  onApplied = EMPTY_FUNCTION,
  onClose,
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { handleAddErrorNotification, handleAddWarningNotification } =
    useNotification()

  const prompt = appointment.follow_up_prompt

  function handleApplyError(error) {
    if (getIsAppointmentDueDateChangedError(error)) {
      handleAddWarningNotification('Appointment.CouplingStaleToastKey')
    } else {
      handleAddErrorNotification('Appointment.CouplingWriteFailedKey')
    }

    onClose()
  }

  async function handleApply() {
    return answerAppointmentFollowUp({
      data: getAppointmentFollowUpApplyData(prompt),
      id: appointment.id,
    })
      .then(() => {
        onApplied(appointment)
        onClose()
      })
      .catch(handleApplyError)
  }

  return (
    <ConfirmationModal
      ActionButtons={AppointmentFollowUpModalButtons}
      actionButtonsProps={{
        cancelText: t(getAppointmentFollowUpDeclineKey(prompt)),
        submitText: t(getAppointmentFollowUpConfirmKey(prompt)),
      }}
      boxSize={SIZE.LARGE}
      description={getAppointmentFollowUpRequestLabel(prompt.request)}
      qaName={QA_NAME_APPOINTMENT_FOLLOW_UP_MODAL}
      title={t('Appointment.CouplingTitleKey')}
      onCancel={onClose}
      onSubmit={handleApply}
    >
      <div className={styles.body}>
        <div className={styles.lines}>
          <Text>
            {t(getAppointmentFollowUpBeforeKey(prompt), {
              value: getAppointmentFollowUpDateLabel({
                date: prompt.current_due_date,
                timezone,
              }),
            })}
          </Text>
          <Text>
            {t('Appointment.CouplingNewKey', {
              value: getAppointmentFollowUpDateLabel({
                date: prompt.target_due_date,
                timezone,
              }),
            })}
          </Text>
          <Text isSecondary>{t(getAppointmentFollowUpReasonKey(prompt))}</Text>
        </div>
        <AppointmentFollowUpModalDayLoad advisory={prompt.day_load_advisory} />
      </div>
    </ConfirmationModal>
  )
}

export default AppointmentFollowUpModal
